module.exports = __webpack_public_path__ + "media/images/social/logo-instagram-5dc3226aeafdae1462d97de1ced99807.svg";